import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListCompany({
    loading,
    filteredCompanies,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Company Name</th>
                        <th>Company Code</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Address</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>District</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="10" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredCompanies.length === 0 ? (
                        <tr>
                            <td colSpan="10" className="text-center text-muted">
                                No companies found
                            </td>
                        </tr>
                    ) : (
                        filteredCompanies.map((c) => {
                            const isActive = c.status === "Active";
                            return (
                                <tr key={c.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="companySelect"
                                            disabled={c.status === "Inactive"}
                                            checked={selected === c.id}
                                            onChange={() => handleSelect(c.id)}
                                        />
                                    </td>
                                    <td>{c.companyName}</td>
                                    <td>{c.companyCode}</td>
                                    <td>{c.emailId}</td>
                                    <td>{c.mobileNo}</td>
                                    <td>{c.address}</td>
                                    <td>{c.countryName || "-"}</td>
                                    <td>{c.stateName || "-"}</td>
                                    <td>{c.cityName || "-"}</td>
                                    <td>
                                        <span
                                            className={`badge ${isActive ? "bg-success" : "bg-secondary"}`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(c)}
                                        >
                                            {isActive ? "Active" : "Inactive"}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
